import {useQuery} from "@tanstack/react-query";
import client from '../../utils/Client'




// GET ALL FORM CATEGORIES
const formCategories = () => client.get('forms/categories');
export const useGetFormCategories = () => useQuery(['categories'], () =>formCategories(), {select: data => data?.data?.result,refetchInterval:60_000})
